module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Armless Sofa_Caramel.0c66bb53.png";